import { BaseEntity } from "@planard/@core/base/BaseEntity";

export class Supersettings extends BaseEntity {
  key: string;
  value: string;
  blob: string;
  type?: number;
  country?: string;
}
